var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgT01Edit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M10.6018 16.7392H17.25",
    stroke: "#605BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71501 1.47856C10.426 0.628804 11.7042 0.504201 12.5715 1.20076C12.6195 1.23854 14.1604 2.43556 14.1604 2.43556C15.1132 3.01159 15.4093 4.23618 14.8203 5.17071C14.789 5.22075 6.07762 16.1174 6.07762 16.1174C5.78779 16.479 5.34785 16.6925 4.87767 16.6976L1.54157 16.7394L0.789903 13.558C0.684607 13.1106 0.789903 12.6408 1.07973 12.2792L9.71501 1.47856Z",
    stroke: "#605BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M8.10242 3.50098L13.1003 7.33917",
    stroke: "#605BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT01Edit);
export default __webpack_public_path__ + "static/media/t01-edit.0cc8840e4be28a44cc773a133099a338.svg";
export { ForwardRef as ReactComponent };